export function formatDocument(editor) {
  if (!editor) return;
  editor.getAction('editor.action.formatDocument')?.run();
}

export function toggleLineComment(editor) {
  if (!editor) return;
  editor.getAction('editor.action.commentLine')?.run();
}

export function duplicateLine(editor) {
  if (!editor) return;
  editor.getAction('editor.action.copyLinesDownAction')?.run();
}

export function selectNextOccurrence(editor) {
  if (!editor) return;
  editor.getAction('editor.action.addSelectionToNextFindMatch')?.run();
}

export function indentSelection(editor) {
  if (!editor) return;
  editor.getAction('editor.action.indentLines')?.run();
}

export function outdentSelection(editor) {
  if (!editor) return;
  editor.getAction('editor.action.outdentLines')?.run();
}

export function openFind(editor) {
  if (!editor) return;
  editor.getAction('actions.find')?.run();
}

export function openReplace(editor) {
  if (!editor) return;
  editor.getAction('editor.action.startFindReplaceAction')?.run();
}

export function toggleWordWrap(editor) {
  if (!editor) return;
  const current = editor.getOption(125); // wordWrap
  editor.updateOptions({ wordWrap: current === 'off' ? 'on' : 'off' });
}

export function zoomIn(editor) {
  if (!editor) return;
  editor.trigger('keyboard', 'editor.action.fontZoomIn', null);
}

export function zoomOut(editor) {
  if (!editor) return;
  editor.trigger('keyboard', 'editor.action.fontZoomOut', null);
}

export function resetZoom(editor) {
  if (!editor) return;
  editor.trigger('keyboard', 'editor.action.fontZoomReset', null);
}
